module.exports = __webpack_public_path__ + "static/media/resizeGoldenGate.6554e7d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/aboutme/resizeGoldenGate.jpg
// module id = 539
// module chunks = 0